
'use strict';

$(document).ready(function() {
    let bikUser = '';
    let korChetUser = '';
    let bankName = '';
    let bank_index = '';
    let bank_city = '';
    let bank_address = '';
    let bank_phone = '';

    // Проверка кода SMS
    $('#password__number2').on('input', function() {
        const maskValue = $(this).val().substring(0, 6);
        $(this).val(maskValue);

        if ($(this).val().length === 6) {
            sendCheckPassword();
        } else {
            $('.button--password').addClass('button--in-active');
        }
    });

    $('#password__number2').on('past', function() {
        const maskValue = $(this).val().substring(0, 6);
        $(this).val(maskValue);

        if ($(this).val().length === 6) {
            sendCheckPassword();
        } else {
            $('.button--password').addClass('button--in-active');
        }
    });

    const formOtp = $('.js-password-form-otp');

    formOtp.on('submit', function(e) {
        e.preventDefault();
        sendCheckPassword();
    });

    function sendCheckPassword() {
        $.ajax({
            type: 'POST',
            url: '/ajax/check-code',
            data: {
                code: $('[name ="code"]').val()
            },
            dataType: 'json',
            success: function(data) {
                if (data) {
                    $('.button--password').removeClass('button--in-active');
                } else {
                    $('.number__error').show();
                }
            },
            error: function(error) {
                console.log(error);
            }
        });
    }

    $('#password__number').on('input', function() {
        if ($('#password__number').inputmask('isComplete')) {
            $.ajax({
                type: 'POST',
                url: '/ajax/check-code',
                data: {
                    code: $('[name ="code"]').val()
                },
                dataType: 'json',
                success: function(data) {
                    if (data) {
                        $('.button--password').removeClass('button--in-active');
                    } else {
                        $('.number__error').show();
                    }
                },
                error: function(error) {
                    console.log(error);
                }
            });
        }
    });

    // Повторная отправка кода
    $('.timer__reset').on('click', function() {
        $.ajax({
            type: 'POST',
            url: '/ajax/send-sms',
            dataType: 'json',
            beforeSend: function() {
                $('.button--password').addClass('button--in-active');
            },
            success: function() {
                console.log('ok');
            },
            error: function(error) {
                console.log(error);
            }
        });
    });

    // Закрытие вкладки с последним экраном
    $('.button--successful').on('click', function() {
        window.close();
    });

    $('.form__checkbox-square').on('click', function() {
        if (
            $(this)
                .parent('.form__checkbox-box')
                .find('.form__input--checkbox')
                .is('[checked]')
        ) {
            $(this).find('.form__checkbox-mark').hide();

            $(this)
                .parent('.form__checkbox-box')
                .find('.form__input--checkbox')
                .attr('checked', false);

            $('.button--form').addClass('button--in-active');
        } else {
            $(this).find('.form__checkbox-mark').show();

            $(this)
                .parent('.form__checkbox-box')
                .find('.form__input--checkbox')
                .attr('checked', true);

            $('.button--form').removeClass('button--in-active');
        }

        const $box = $(this).closest('.button-box');

        if ($box.length) {
            const allChecked =
                $box.find('.form__input--checkbox[checked]').length ===
                $box.find('.form__input--checkbox').length;

            if (allChecked) {
                $box.find('.button--form').removeClass('button--in-active');
            } else {
                $box.find('.button--form').addClass('button--in-active');
            }
        }
    });

    // Согласие на обработку персональных данных
    $('#agree__data').on('change', function() {
        $('.button--agree').toggleClass('button--in-active');
    });

    // ========================================
    // ВАЛИДАЦИЯ РАСЧЁТНОГО СЧЁТА
    // ========================================

    function validateRs(rs, bik, error) {
        var result = false;

        if (typeof rs === 'number') {
            rs = rs.toString();
        } else if (typeof rs !== 'string') {
            rs = '';
        }

        if (!rs.length) {
            error.code = 1;
            error.message = 'Р/С пуст';
        } else if (/[^0-9]/.test(rs)) {
            error.code = 2;
            error.message = 'Р/С может состоять только из цифр';
        } else if (rs.length !== 20) {
            error.code = 3;
            error.message = 'Р/С может состоять только из 20 цифр';
        } else {
            var bikRs = bik.toString().slice(-3) + rs;
            var checksum = 0;

            var coefficients = [
                7, 1, 3, 7, 1, 3,
                7, 1, 3, 7, 1, 3,
                7, 1, 3, 7, 1, 3,
                7, 1, 3, 7, 1
            ];

            for (var i in coefficients) {
                checksum += coefficients[i] * (bikRs[i] % 10);
            }

            if (checksum % 10 === 0) {
                result = true;
            } else {
                error.code = 4;
                error.message = 'Неправильное контрольное число';
            }
        }

        return result;
    }

    // ========================================
    // ОТПРАВКА ОШИБКИ ВАЛИДАЦИИ БИК
    // ========================================

    function sendCardNumberError() {
        $('.number__error--bik').show();

        $.ajax({
            type: 'POST',
            url: '/ajax/card-number-validation-error',
            data: {
                'card-number': $('[name ="card-number"]').val(),
                'bik': $('[name ="card-bik"]').val(),
                'kor_number': '',
                'bank_name': ''
            },
            dataType: 'json',
            success: function() {
                console.log('Вы ошиблись');
            },
            error: function(error) {
                console.log(error);
            }
        });
    }

    // ========================================
    // НОВАЯ ПРОВЕРКА БИК ЧЕРЕЗ DADATA
    // ========================================

    var $bankBikInput = $('#card__bik');
    var $bankAccountInput = $('#card__number');

    var bikRequest = null;
    var bikRequestId = 0;
    var pendingBik = '';

    // Проверяем, что текущий БИК подтверждён
    function isBankVerified() {
        return Boolean(
            bikUser &&
            bikUser === String($bankBikInput.val() || '').replace(/\D/g, '') &&
            korChetUser &&
            bankName.toLowerCase().includes('сбербанк')
        );
    }

    // Управление кнопками продолжения
    function updateBankButtons() {
        if (!$bankBikInput.length) {
            return;
        }

        var isAccountComplete =
            $bankAccountInput.length &&
            $bankAccountInput.inputmask('isComplete');

        var enabled = isBankVerified() && isAccountComplete;

        $('.button--number, .button--score')
            .toggleClass('button--in-active', !enabled);
    }

    // Сброс данных банка
    function resetBankData() {
        bikUser = '';
        korChetUser = '';
        bankName = '';

        $bankAccountInput.prop('disabled', true);

        updateBankButtons();
    }

    // Основной запрос к новому API
    function checkBankByBik(bikValue) {
        var requestId = ++bikRequestId;

        pendingBik = bikValue;

        bikRequest = $.ajax({
            type: 'POST',
            url: '/ajax/dadata-proxy-bik',
            contentType: 'application/json',
            dataType: 'json',

            // Тело запроса
            data: JSON.stringify({
                query: bikValue
            }),

            success: function(response) {
                // Игнорируем устаревшие ответы
                if (
                    requestId !== bikRequestId ||
                    String($bankBikInput.val() || '').replace(/\D/g, '') !== bikValue
                ) {
                    return;
                }

                // Получаем массив банков
                var suggestions =
                    response && Array.isArray(response.suggestions)
                        ? response.suggestions
                        : [];

                // Ищем банк по введённому БИК
                var suggestion = suggestions.find(function(item) {
                    return (
                        item &&
                        item.data &&
                        item.data.bic === bikValue
                    );
                });

                var bankData = suggestion && suggestion.data;

                // Название банка берём из unrestricted_value
                var fullName =
                    suggestion && suggestion.unrestricted_value;

                // Проверяем, что банк найден и это Сбербанк
                if (
                    !bankData ||
                    !fullName ||
                    !fullName.toLowerCase().includes('сбербанк') ||
                    !bankData.correspondent_account
                ) {
                    resetBankData();
                    sendCardNumberError();
                    return;
                }

                // Сохраняем данные банка
                bikUser = bankData.bic;
                korChetUser = bankData.correspondent_account;
                bankName = fullName;

                // Разблокируем поле расчётного счёта
                $bankAccountInput.prop('disabled', false);

                // Проверяем возможность продолжения
                updateBankButtons();
            },

            error: function(xhr, status) {
                // Игнорируем отменённые запросы
                if (
                    status === 'abort' ||
                    requestId !== bikRequestId
                ) {
                    return;
                }

                resetBankData();

                console.error('Ошибка проверки БИК:', xhr);

                $('.number__error--bik').show();
            },

            complete: function() {
                if (requestId === bikRequestId) {
                    pendingBik = '';
                }
            }
        });
    }

    // Обработчик ввода и изменения БИК
    $bankBikInput.on('input change', function() {
        $('.number__error').hide();

        var bikValue = String(
            $(this).val() || ''
        ).replace(/\D/g, '');

        // Не отправляем повторно тот же запрос
        if (
            bikRequest &&
            bikRequest.readyState !== 4 &&
            pendingBik === bikValue
        ) {
            return;
        }

        // БИК уже прошёл проверку
        if (
            bikValue === bikUser &&
            isBankVerified()
        ) {
            updateBankButtons();
            return;
        }

        // Инвалидируем предыдущий запрос
        ++bikRequestId;

        // Отменяем предыдущий запрос
        if (
            bikRequest &&
            bikRequest.readyState !== 4
        ) {
            bikRequest.abort();
        }

        bikRequest = null;
        pendingBik = '';

        resetBankData();

        // Проверяем формат БИК
        if (
            /^04\d{7}$/.test(bikValue) &&
            $bankBikInput.inputmask('isComplete')
        ) {
            checkBankByBik(bikValue);
        }
    });

    // Проверка заполненности расчётного счёта
    $bankAccountInput.on('input change', function() {
        $('.number__error').hide();
        updateBankButtons();
    });

    // ========================================
    // ПРОВЕРКА И СОХРАНЕНИЕ РАСЧЁТНОГО СЧЁТА
    // ========================================

    $('.button--number').on('click', function(e) {
        e.preventDefault();

        // Не продолжаем без подтверждённого БИК
        if (!isBankVerified()) {
            $('.number__error--bik').show();
            updateBankButtons();
            return;
        }

        const bik = bikUser;

        let error = {
            code: '',
            message: ''
        };

        if (
            validateRs(
                $('#card__number').val(),
                bik,
                error
            )
        ) {
            $.ajax({
                type: 'POST',
                url: '/ajax/save-card-number',

                data: {
                    'paymentType': 'PAYMENT_TO_ACCOUNT',
                    'card-number': $('[name ="card-number"]').val(),
                    'bik': $('[name ="card-bik"]').val(),
                    'kor_number': korChetUser,
                    'bank_name': bankName,
                    'bank_index': bank_index,
                    'bank_city': bank_city,
                    'bank_address': bank_address,
                    'bank_phone': bank_phone
                },

                dataType: 'json',

                success: function(data) {
                    if (data) {
                        let link = $('.button--number').attr('href');
                        location.href = link;
                    } else {
                        $('.number__error')
                            .text('Что то пошло не так. Попробуйте снова')
                            .show();
                    }
                },

                error: function(error) {
                    console.log(error);
                }
            });
        } else {
            $('.number__error--score').show();

            $.ajax({
                type: 'POST',
                url: '/ajax/card-number-validation-error',

                data: {
                    'card-number': $('[name ="card-number"]').val(),
                    'bik': $('[name ="card-bik"]').val(),
                    'kor_number': korChetUser,
                    'bank_name': bankName,
                    'bank_index': bank_index,
                    'bank_city': bank_city,
                    'bank_address': bank_address,
                    'bank_phone': bank_phone
                },

                dataType: 'json',

                success: function() {
                    console.log('Вы ошиблись');
                },

                error: function(error) {
                    console.log(error);
                }
            });
        }
    });

    // ========================================
    // ОТПРАВКА ФОРМЫ НА СТРАНИЦАХ С ТАБАМИ
    // ========================================

    $(document).on('click', '.button--ajax', function(e) {
        e.preventDefault();

        const bik = bikUser;

        let error = {
            code: '',
            message: ''
        };

        // Проверка БИК для вкладки банковских реквизитов
        if (
            $(this).hasClass('button--score') &&
            !isBankVerified()
        ) {
            $('.number__error--bik').show();
            updateBankButtons();
            return;
        }

        let serializeFormData;

        function sendAjax(serializeFormData) {
            $.ajax({
                url: '/ajax/save-card-number',
                method: 'POST',
                dataType: 'json',
                data: serializeFormData,

                success: function() {
                    let link = $('.button--ajax').attr('href');
                    location.href = link;
                },

                error: function(data) {
                    console.log(
                        'Внимание! произошла ошибка:' + data
                    );
                }
            });
        }

        if ($(this).hasClass('button--phone')) {
            serializeFormData = $('form[data-tab="phoneNumber"]').serialize();

            sendAjax(serializeFormData);
        } else if (
            $(this).hasClass('button--score') &&
            validateRs($('#card__number').val(), bik, error)
        ) {
            serializeFormData = $('form[data-tab="bankDetails"]').serialize();

            serializeFormData += '&' + $.param({
                kor_number: korChetUser,
                bank_name: bankName,
                bank_index: bank_index,
                bank_city: bank_city,
                bank_address: bank_address,
                bank_phone: bank_phone
            });

            sendAjax(serializeFormData);
        } else if (
            $(this).hasClass('button--score') &&
            !validateRs($('#card__number').val(), bik, error)
        ) {
            $('.number__error--score').show();

            $.ajax({
                type: 'POST',
                url: '/ajax/card-number-validation-error',

                data: {
                    'card-number': $('[name ="card-number"]').val(),
                    'bik': $('[name ="card-bik"]').val(),
                    'kor_number': korChetUser,
                    'bank_name': bankName,
                    'bank_index': bank_index,
                    'bank_city': bank_city,
                    'bank_address': bank_address,
                    'bank_phone': bank_phone
                },

                dataType: 'json',

                success: function() {
                    console.log('Вы ошиблись');
                },

                error: function(error) {
                    console.log(error);
                }
            });
        }
    });

    // ========================================
    // ТАЙМЕР ОБРАТНОГО ОТСЧЁТА
    // ========================================

    function timer() {
        $('.timer__reset').removeClass('timer__reset--active');
        $('.timer__text').addClass('timer__text--active');

        const timerBlock = $('.timer__seconds');
        const num = 30;

        timerBlock.html(num);

        let index = num;

        const timerId = setInterval(function() {
            timerBlock.html(--index);
        }, 1000);

        setTimeout(function() {
            clearInterval(timerId);

            $('.timer__reset').addClass('timer__reset--active');
            $('.timer__text').removeClass('timer__text--active');
        }, num * 1000);
    }

    timer();

    $('.timer__reset').on('click', function() {
        timer();
    });

    $($('#inn')).on('input', function() {
        $('#inn').removeClass('error');
    });

    $($('#snils')).on('input', function() {
        $('#snils').removeClass('error');
    });

    // ========================================
    // МАСКИ ПОЛЕЙ
    // ========================================

    $('#contract_data').inputmask('99.99.9999');
    $('#obtaining_contract').inputmask('99.99.9999');
    $('#payment_contract').inputmask('99.99.9999');
    $('#credit_contract_data').inputmask('99.99.9999');
    $('#birthday').inputmask('99.99.9999');

    $('#birthday-alias').inputmask({
        alias: 'datetime',
        inputFormat: 'dd.mm.yyyy',
        placeholder: 'дд.мм.гггг'
    });

    $('#passport_date').inputmask('99.99.9999');
    $('#passport').inputmask('9999 999999');
    $('#length_stay').inputmask('99.99.9999 - 99.99.9999');
    $('#term_residence').inputmask('99.99.9999 - 99.99.9999');
    $('#date_application').inputmask('99.99.9999');

    $('#password__number').inputmask({
        mask: '999999'
    }).on('paste', function() {
        if ($('#password__number').inputmask('isComplete')) {
            $.ajax({
                type: 'POST',
                url: '/ajax/check-code',

                data: {
                    code: $('[name ="code"]').val()
                },

                dataType: 'json',

                success: function(data) {
                    if (data) {
                        $('.button--password').removeClass('button--in-active');
                    } else {
                        $('.number__error').show();
                    }
                },

                error: function(error) {
                    console.log(error);
                }
            });
        }
    });

    // ========================================
    // МАСКА БИК И ОБРАБОТКА ВСТАВКИ
    // ========================================

    $('#card__bik').inputmask({
        mask: '049999999'
    }).on('paste', function() {
        // Даём Inputmask обработать вставку
        setTimeout(function() {
            $bankBikInput.trigger('change');
        }, 0);
    });

    // Маска расчётного счёта
    $('#card__number').inputmask({
        mask: '40819999999999999999'
    }).on('paste keyup', function() {
        updateBankButtons();
    });

    $('.js-only-letters').on('input', function() {
        const val = $(this).val();

        $(this).val(val.match('[A-Za-zА-Яа-яЁё]*'));
    });

    $('.js-passport-series').on('input', function() {
        const val = $(this).val();

        console.log(888, val.replace('[0-9]{4}', ''));

        $(this).val(
            val.match('[0-9]{4}')
                ? val.slice(0, 4)
                : val
        );
    });

    $('.js-passport-number').on('input', function() {
        const val = $(this).val();

        console.log(888, val.replace('[0-9]{4}', ''));

        $(this).val(
            val.match('[0-9]{6}')
                ? val.slice(0, 6)
                : val
        );
    });

    $('.js-birth-series').on('input', function() {
        let val = $(this).val();

        $(this).val(
            val.replace(/[^-A-Za-zА-Яа-яЁё]/g, '')
        );
    });

    $('input[type="text"]').on('focus', function() {
        $('.popuptext').removeClass('show');
    });

    // ========================================
    // ВОПРОСЫ И ПОПАПЫ
    // ========================================

    $('.questions__text').on('click', function() {
        const questionBlock = $(this).parents('.questions__item');

        questionBlock.find('.questions__answer').slideToggle();
        questionBlock.find('.questions__arrow')
            .toggleClass('questions__arrow--active');

        questionBlock.toggleClass('questions__item--active');
    });

    $('.process-description__item').on('click', function() {
        const popupBlock = $(this).find('.process-description__popup');

        popupBlock.toggleClass('show');
    });

    $('.popup').on('click', function() {
        const popup = $(this).find('.popuptext');

        popup.toggleClass('show');
    });

    // ========================================
    // МАСКА ТЕЛЕФОНА
    // ========================================

    $('#phone__number').inputmask({
        mask: '+7 (999) 9999999'
    });

    if ($('#phone__number').length > 0) {
        if (
            $('#phone__number').inputmask('isComplete') &&
            $('#phone__number').val().replace(/[^0-9]/g, '').length === 11
        ) {
            $('.button').removeClass('button--in-active');
        } else {
            $('.button').addClass('button--in-active');
        }
    }
});

// ========================================
// POPUP НА СТРАНИЦЕ
// ========================================

function popupFunction() {
    console.log('');
}

// ========================================
// НАВИГАЦИЯ НАЗАД
// ========================================

if (location.href.indexOf('protectionclaim/address') >= 0) {
    const back = $('.js-button-back');
    const backHref = document.referrer.split('/').slice(3).join('/');

    back.attr('href', `/${backHref}`);
}

if (
    document.referrer.indexOf(
        'protectionclaim/medical-institution'
    ) >= 0
) {
    const back = $('.js-button-back');
    const backHref = document.referrer.split('/').slice(3).join('/');

    back.attr('href', `/${backHref}`);
}

// ========================================
// МОДАЛЬНОЕ ОКНО НАЛОГОВ
// ========================================

if (document.getElementById('open-tax-modal')) {
    document
        .getElementById('open-tax-modal')
        .addEventListener('click', showTaxModal);

    function showTaxModal(e) {
        document.querySelector('.cover').style.display = 'flex';
        document.body.style.overflowY = 'hidden';

        let domRectY =
            e.target.getBoundingClientRect().top +
            window.scrollY;

        document.querySelector('.modal-tax').style.top =
            (domRectY + 24) + 'px';

        document.querySelector('.modal-tax').style.display = 'flex';
    }

    document
        .querySelector('.cover')
        .addEventListener('click', hideTaxModal);

    function hideTaxModal() {
        document.body.style.overflowY = 'auto';
        document.querySelector('.modal-tax').style.display = 'none';
        document.querySelector('.cover').style.display = 'none';
    }
}

// ========================================
// РАБОТА ТАБОВ
// ========================================

if (document.querySelectorAll('.tab-changes__item').length !== 0) {
    let tabButtonsCollection = [
        ...document.querySelectorAll('.tab-changes__item')
    ];

    tabButtonsCollection.map(element => {
        element.addEventListener('click', function() {
            let tabName = this.dataset.tab;

            // Сбрасываем активные табы
            tabButtonsCollection.map(item => {
                item.classList.remove('active');
            });

            element.classList.toggle('active');

            sendLogAjax(
                element,
                'change_tab',
                element.textContent
            );

            document
                .querySelector('.button--ajax')
                .classList.add('button--in-active');

            let tabsCollection = [
                ...document.querySelectorAll('.tab-changes__content')
            ];

            tabsCollection.map(elem => {
                if (elem.dataset.tab === tabName) {
                    tabsCollection.map(item => {
                        item.classList.remove('active');
                    });

                    elem.classList.toggle('active');

                    if (elem.dataset.tab === 'phoneNumber') {
                        document
                            .querySelector('.button--ajax')
                            .classList.add('button--phone');

                        document
                            .querySelector('.button--ajax')
                            .classList.remove('button--score');

                        if (
                            document
                                .getElementById('phone__number')
                                .value.replace(/[^0-9]/g, '')
                                .length === 11
                        ) {
                            document
                                .querySelector('.button--ajax')
                                .classList.remove('button--in-active');
                        } else {
                            document
                                .querySelector('.button--ajax')
                                .classList.add('button--in-active');
                        }
                    } else if (elem.dataset.tab === 'bankDetails') {
                        document
                            .querySelector('.button--ajax')
                            .classList.remove('button--phone');

                        document
                            .querySelector('.button--ajax')
                            .classList.add('button--score');
                    } else if (elem.dataset.tab === 'payment') {
                        document
                            .querySelector('.button--ajax')
                            .addEventListener(
                                'click',
                                submitTechchangesFormInChange.bind(this, elem)
                            );
                    } else if (elem.dataset.tab === 'period') {
                        document
                            .querySelector('.button--ajax')
                            .addEventListener(
                                'click',
                                submitTechchangesFormInChange.bind(this, elem)
                            );
                    }
                }

                // Очистка банковских реквизитов
                if (elem.dataset.tab === 'bankDetails') {
                    let inputs = [
                        ...elem.querySelectorAll('input')
                    ];

                    inputs.map(input => {
                        if (
                            input.getAttribute('id') === 'card__bik' ||
                            input.getAttribute('id') === 'card__number'
                        ) {
                            input.value = '';
                        }
                    });
                } else if (elem.dataset.tab === 'payment') {
                    document.getElementById('contractPaymentNext').value = '';
                } else if (elem.dataset.tab === 'period') {
                    document.getElementById('contractPeriodNext').value = '';
                }
            });
        });
    });

    function submitTechchangesFormInChange(form) {
        form.submit();
    }

    if (document.querySelector('form[data-tab="phoneNumber"]')) {
        document
            .querySelector('.button--ajax')
            .classList.add('button--phone');
    }

    // Убираем копейки в поле текущего взноса
    if (document.getElementById('contractPaymentPrev')) {
        let contractPaymentPreview =
            document.getElementById('contractPaymentPrev');

        let y = contractPaymentPreview.value.indexOf('.');

        if (contractPaymentPreview.value.slice(y + 1) === '00') {
            contractPaymentPreview.value =
                contractPaymentPreview.value.slice(0, y);
        }

        contractPaymentPreview.addEventListener('keyup', function() {
            if (this.value.indexOf('.') > -1) {
                let x = this.value.indexOf('.');

                this.value = this.value.slice(0, x + 3);

                if (this.value.slice(x + 1) === '00') {
                    this.value = this.value.slice(0, x);
                }
            }
        });
    }

    // Валидация желаемого взноса
    if (document.getElementById('contractPaymentNext')) {
        let inputPayment =
            document.getElementById('contractPaymentNext');

        inputPayment.addEventListener('keyup', function() {
            let min = this.nextElementSibling
                .firstElementChild
                .textContent.split(' ')
                .join('');

            console.log(333, min);

            if (+this.value < +min) {
                this.classList.add('error-input');
                this.nextElementSibling.style.opacity = '1';

                document
                    .querySelector('.button--ajax')
                    .classList.add('button--in-active');
            } else {
                this.classList.remove('error-input');
                this.nextElementSibling.style.opacity = '0';

                document
                    .querySelector('.button--ajax')
                    .classList.remove('button--in-active');
            }

            if (this.value.indexOf('.') > -1) {
                let x = this.value.indexOf('.');

                this.value = this.value.slice(0, x + 3);

                if (this.value.slice(x + 1) === '00') {
                    this.value = this.value.slice(0, x);
                }
            }
        });
    }

    // Валидация желаемого срока
    if (document.getElementById('contractPeriodNext')) {
        let inputPeriod =
            document.getElementById('contractPeriodNext');

        inputPeriod.addEventListener('keyup', function() {
            let min = this.nextElementSibling
                .firstElementChild
                .textContent.split(' ')
                .join('');

            let max = this.nextElementSibling
                .lastElementChild
                .textContent.split(' ')
                .join('');

            if (
                +this.value < +min ||
                +this.value > +max
            ) {
                this.classList.add('error-input');
                this.nextElementSibling.style.opacity = '1';

                document
                    .querySelector('.button--ajax')
                    .classList.add('button--in-active');
            } else {
                this.classList.remove('error-input');
                this.nextElementSibling.style.opacity = '0';

                document
                    .querySelector('.button--ajax')
                    .classList.remove('button--in-active');
            }

            this.value = this.value.toFixed();
        });

        let currentPeriod =
            document.getElementById('contractPeriodPrev');

        currentPeriod.addEventListener('keyup', function() {
            this.value = this.value.toFixed();
        });
    }
}

// ========================================
// ЧЕКБОКСЫ IFTS-CERTIFICATE
// ========================================

if (document.querySelector('.iftscertificate-form')) {
    let checkboxCollection = [
        ...document
            .querySelector('.iftscertificate-form')
            .querySelectorAll('input[type=checkbox]')
    ];

    checkboxCollection.map(item => {
        item.addEventListener('change', function() {
            let newStateCheckboxCollection = [
                ...document
                    .querySelector('.iftscertificate-form')
                    .querySelectorAll('input[type=checkbox]')
            ];

            let filtered = newStateCheckboxCollection.filter(elem => {
                if (elem.checked) {
                    return true;
                }
            });

            if (
                filtered.length &&
                document
                    .querySelector('.button')
                    .classList.contains('button--in-active')
            ) {
                document
                    .querySelector('.button')
                    .classList.remove('button--in-active');
            } else if (
                filtered.length === 0 &&
                !document
                    .querySelector('.button')
                    .classList.contains('button--in-active')
            ) {
                document
                    .querySelector('.button')
                    .classList.add('button--in-active');
            }
        });
    });
}

// ========================================
// ЛОГИРОВАНИЕ ДЕЙСТВИЙ
// ========================================

if (document.querySelector('.tabs__name')) {
    let tabsCollection = [
        ...document.querySelectorAll('.tabs__name')
    ];

    tabsCollection.map(el => {
        el.addEventListener('click', e => {
            sendLogAjax(
                e,
                'change_tab',
                e.target.textContent
            );
        });
    });
}

if (document.querySelector('.open__pdf')) {
    let openFileCollection = [
        ...document.querySelectorAll('.open__pdf')
    ];

    openFileCollection.map(el => {
        el.addEventListener('click', e => {
            e.stopPropagation();

            sendLogAjax(
                e,
                'view_file',
                e.target.getAttribute('href')
            );

            window.location.href = e.target.getAttribute('href');
        });
    });
}

if (document.querySelector('.timer__reset')) {
    let timerResetCollection = [
        ...document.querySelectorAll('.timer__reset')
    ];

    timerResetCollection.map(el => {
        el.addEventListener('click', e => {
            sendLogAjax(e, 'resending sms');
        });
    });
}

function sendLogAjax(e, action, info = null) {
    let formData = new FormData();

    formData.append(
        'module',
        window.location.pathname.split('/')[1]
    );

    formData.append('action', action);
    formData.append('info', info);

    fetch('/ajax/save-front-logs', {
        method: 'POST',
        body: formData
    }).then(response => console.log(response));
}
